export default __webpack_public_path__ + "static/media/5_Still.d8cdc9e0.jpg";